import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AisRestService, ConditionsResourceIdentifier, ScreensQuestionResource } from '@Components/mras/core';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@Shared/shared.module';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'jhi-disclosure-search-input',
    templateUrl: './disclosure-search-input.component.html',
    imports: [SharedModule, NgbTypeaheadModule]
})
export class DisclosureSearchInputComponent implements OnInit {
    @Input()
    placeholder = 'Search all that apply...';
    @Input()
    name: string;
    @Input()
    searchIdentifier: ConditionsResourceIdentifier;
    @Input()
    filter: string[];
    @Input() question: ScreensQuestionResource;

    @Output()
    action = new EventEmitter<string>();

    value: string;
    disabled: boolean;
    search: any;

    constructor(private restService: AisRestService) {}

    ngOnInit(): void {
        this.search = (text$: Observable<string>) =>
            text$.pipe(
                debounceTime(300),
                distinctUntilChanged(),
                switchMap(term =>
                    this.restService.searchDisclosure(this.searchIdentifier, term).pipe(
                        map(e => e.conditions),
                        catchError(() => of([]))
                    )
                )
            );
    }

    onClick() {
        this.action.emit(this.value);
        this.value = null;
    }
}
